import request from 'api/drivers/socket';

export default function socketEventsRoute() {
  return request({ url: '/subscribe/all', method: 'POST' });
}
